var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconGuestCount = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.201,
    height: 10.641,
    viewBox: "0 0 15.201 10.641",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_supervisor_account_24px",
    d: "M13.021,10.32a1.9,1.9,0,1,0-1.9-1.9A1.894,1.894,0,0,0,13.021,10.32Zm-5.7-.76A2.28,2.28,0,1,0,5.04,7.28,2.271,2.271,0,0,0,7.32,9.56Zm5.7,2.28c-1.391,0-4.18.7-4.18,2.09v1.71H17.2v-1.71C17.2,12.54,14.412,11.84,13.021,11.84Zm-5.7-.76c-1.771,0-5.32.889-5.32,2.66v1.9H7.32v-1.71a3,3,0,0,1,1.8-2.637A9.336,9.336,0,0,0,7.32,11.08Z",
    transform: "translate(-2 -5)",
    fill: "#727272"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconGuestCount);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-guest-count.53de250eb9e4905e34dcaae592779d27.svg";